<template>
  <v-data-table
        :no-data-text="$t('noData')"
        :no-results-text="$t('noResults')"
    item-key="name"
    :loading="loading"
    :loading-text="$t('loading_text')"
    :headers="translatedHeaders"
    :items="plannedTrips"
    :search="search"
    :footer-props="footerProps"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        :label="$t('search')"
        class="mx-4"
      ></v-text-field>
    </template>

    <template v-slot:item.trip.route.name="{ item }">
      <div class="d-flex align-center">
        <a class="font-weight-bold primary--text text-subtitle-2 me-1" @click.stop="openDetails(item)">
          {{ (item.trip && item.trip.route) ? item.trip.route.name : 'مسار غير محدد' }}
        </a>
        <v-btn icon x-small color="primary" @click.stop="openDetails(item)" title="عرض التفاصيل الكاملة">
          <v-icon x-small>mdi-open-in-new</v-icon>
        </v-btn>
      </div>
    </template>

    <template v-slot:item.driver.name="{ item }">
      <div class="d-flex align-center py-1">
        <v-avatar size="32" color="grey lighten-3" class="me-2 border-grey">
          <img v-if="item.driver && item.driver.avatar_url" :src="item.driver.avatar_url" alt="Captain Avatar" />
          <v-icon v-else size="20" color="grey darken-1">mdi-account</v-icon>
        </v-avatar>
        <div>
          <div class="font-weight-bold text-body-2 text-dark-primary">
            <a v-if="item.driver" class="text-dark-primary" @click.stop="displayDriver(item.driver.id)">
              {{ item.driver.name }}
            </a>
            <span v-else class="text-dark-secondary">غير محدد</span>
            <v-chip v-if="item.is_tracking_stale" x-small color="error" dark class="ms-1 font-weight-bold" style="white-space: nowrap;" title="لم يصل تحديث للموقع منذ أكثر من 5 دقائق">
              🔺 مشكلة اتصال
            </v-chip>
          </div>
          <div class="text-caption text-dark-secondary font-weight-medium" dir="ltr" style="text-align: right;">
            {{ getDriverPhone(item.driver) }}
          </div>
        </div>
      </div>
    </template>

    <template v-slot:item.bus.license="{ item }">
      <a v-if="item.bus" @click.stop="displayBus(item.bus)">{{
        item.bus.license
      }}</a>
    </template>

    <template v-slot:item.planned_date="{ item }">
      <div class="d-flex align-center">
        <small class="me-2">{{ item.planned_date | moment("LL") }}</small>
        <v-chip v-if="item.is_paused" x-small color="grey darken-2" dark class="font-weight-bold">
          ⏸ متوقفة مؤقتًا
        </v-chip>
      </div>
    </template>

    <template v-slot:item.planned_start_date_time="{ item }">
      <small class="text-muted">{{ item.planned_start_date_time | moment("LT") }}</small>
    </template>

    <template v-slot:item.planned_end_date_time="{ item }">
      <small class="text-muted">{{ item.planned_end_date_time | moment("LT") }}</small>
    </template>

    <template v-slot:item.started_at="{ item }">
      <small class="text-muted">{{ item.started_at | moment("LT") }}</small>
    </template>

    <template v-slot:item.ended_at="{ item }">
      <small class="text-muted">{{ item.ended_at | moment("LT") }}</small>
    </template>

    <template v-slot:item.station_wait_minutes="{ item }">
      <div class="d-flex align-center justify-center">
        <span class="font-weight-bold primary--text me-1">{{ item.station_wait_minutes || 5 }} دقيقة</span>
        <v-btn icon x-small color="primary" @click.stop="editWaitTime(item)">
          <v-icon x-small>mdi-pencil</v-icon>
        </v-btn>
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex align-center">
        <v-btn v-if="showNotification && item.reservations_count >0" depressed small density="compact" color="info"
        :icon="true"
        class="me-1"
        @click="sendNotification(item)">
          <v-icon dark> mdi-bell </v-icon>
        </v-btn>

        <!-- Pause / Reactivate Button (Only for future unstarted trips) -->
        <template v-if="!item.movement_started_at && !item.ended_at && !item.cancelled_at">
          <v-btn
            v-if="!item.is_paused"
            x-small
            color="warning"
            outlined
            class="font-weight-bold px-2"
            @click.stop="pausePlannedTrip(item)"
          >
            <v-icon x-small left>mdi-pause-circle-outline</v-icon>
            إيقاف مؤقت
          </v-btn>

          <v-btn
            v-else
            x-small
            color="success"
            outlined
            class="font-weight-bold px-2"
            @click.stop="reactivatePlannedTrip(item)"
          >
            <v-icon x-small left>mdi-play-circle-outline</v-icon>
            إعادة التفعيل
          </v-btn>
        </template>
      </div>
    </template>
  </v-data-table>
</template>

<script>

export default {
  props: {
    plannedTrips: Array,
    showStart: {
      type: Boolean,
      default: false,
    },
    showEnd: {
      type: Boolean,
      default: false,
    },
    showNotification: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      search: "",
      headers: [
        { text: "planned_date", value: "planned_date", align: "start"},
        { text: "Driver", value: "driver.name" },
        { text: "license", value: "bus.license"},
        { text: "route", value: "trip.route.name"},
        { text: "planned_start", value: "planned_start_date_time" },
        { text: "planned_end", value: "planned_end_date_time" },
        { text: "station_wait_minutes", value: "station_wait_minutes", align: "center" },
        { text: "reservations", value: "reservations_count" },
        { text: " ", value: "actions", sortable: false},
      ],
    };
  },
  mounted() {
    let finalHeaders = this.headers;
    if (this.showStart) {
      finalHeaders.push({ text: "started_at", value: "started_at" });
    }
    if (this.showEnd) {
      finalHeaders.push({ text: "ended_at", value: "ended_at" });
    }
    this.headers = finalHeaders;
  },
  computed: {
    translatedHeaders() {
      return this.headers.map(header => ({
        ...header,
        text: header.text === 'station_wait_minutes' ? 'مدة الانتظار' : this.$t(header.text)
      }));
    },
    footerProps() {
      return {
        itemsPerPageText: this.$t("rows_per_page"),
      }
    }
  },
  methods: {
    editWaitTime(item) {
      this.$swal({
        title: 'تعديل مدة الانتظار بالمحطة',
        text: 'أدخل مدة الانتظار الجديدة بالدقائق (ستطبق فورًا على الرحلة الحالية)',
        input: 'number',
        inputValue: item.station_wait_minutes || 5,
        inputAttributes: {
          min: 1,
          step: 1
        },
        showCancelButton: true,
        confirmButtonText: 'حفظ',
        cancelButtonText: 'إلغاء',
        inputValidator: (value) => {
          if (!value || parseInt(value) <= 0) {
            return 'يرجى إدخال عدد دقائق صحيح أكثر من 0';
          }
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          const newMinutes = parseInt(result.value);
          axios.post(`/planned-trips/${item.id}/update-wait-time`, {
            station_wait_minutes: newMinutes
          }).then((res) => {
            this.$set(item, 'station_wait_minutes', newMinutes);
            this.$notify({
              title: "تم الحفظ",
              text: "تم تعديل مدة الانتظار بنجاح.",
              type: "success"
            });
          }).catch((err) => {
            this.$swal("خطأ", "فشل تحديث مدة الانتظار", "error");
          });
        }
      });
    },
    openDetails(item) {
      this.$emit("open-details", item);
    },
    getDriverPhone(driver) {
      if (!driver) return "—";
      return driver.tel_number || driver.phone_number || "—";
    },
    displayRoute(route_id) {
      this.$router.push({
        name: "view-route",
        params: { route_id: route_id },
      });
    },
    displayDriver(driver_id) {
      this.$router.push({
        name: "view-user",
        params: { user_id: driver_id, },
      });
    },
    displayBus(bus) {
      //show swal with bus info
      this.$swal({
        title: this.$t("bus_info"),
        html: `
          <div class="text-left">
            <p><b>${this.$t('license')}:</b> ${bus.license}</p>
            <p><b>${this.$t('capacity')}:</b> ${bus.capacity}</p>
          </div>
        `,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: this.$t("ok"),
      });
    },
    sendNotification(trip) {
      this.$emit("send-notification", trip);
    },
    pausePlannedTrip(item) {
      const resCount = item.reservations_count || 0;
      let text = resCount > 0
        ? `هذه الرحلة عليها ${resCount} حجوزات حالية.\nإيقاف الرحلة مؤقتًا لن يلغي هذه الحجوزات.\nهل تريد المتابعة؟`
        : "هل تريد إيقاف هذه الرحلة مؤقتًا؟\nلن يتمكن السائق من بدء الرحلة ولن تظهر للحجوزات الجديدة حتى يتم إعادة تفعيلها.";

      this.$swal.fire({
        title: "إيقاف الرحلة مؤقتًا",
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم، إيقاف مؤقت",
        cancelButtonText: "إلغاء",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(`/planned-trips/${item.id}/pause`)
            .then((res) => {
              this.$set(item, 'is_paused', true);
              this.$notify({
                title: "تم الإيقاف",
                text: "تم إيقاف الرحلة مؤقتًا بنجاح.",
                type: "success"
              });
            })
            .catch((err) => {
              const msg = err.response ? err.response.data.message : "فشل إيقاف الرحلة مؤقتًا";
              this.$swal("خطأ", msg, "error");
            });
        }
      });
    },
    reactivatePlannedTrip(item) {
      this.$swal.fire({
        title: "إعادة تفعيل الرحلة",
        text: "هل تريد إعادة تفعيل هذه الرحلة لتعود إلى التشغيل الطبيعي؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "نعم، إعادة تفعيل",
        cancelButtonText: "إلغاء",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(`/planned-trips/${item.id}/reactivate`)
            .then((res) => {
              this.$set(item, 'is_paused', false);
              this.$notify({
                title: "تمت إعادة التفعيل",
                text: "تمت إعادة تفعيل الرحلة بنجاح.",
                type: "success"
              });
            })
            .catch((err) => {
              const msg = err.response ? err.response.data.message : "فشل إعادة تفعيل الرحلة";
              this.$swal("خطأ", msg, "error");
            });
        }
      });
    },
  },
};
</script>
